import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchTicketStatus = createAsyncThunk(
    'tickets/fetchStatus',
    async (ticketId, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/meonsupport/checkStatus/${ticketId}`, { timeout: 20000 });
            return response.data;
        } catch (error) {
            if (error.code === "ECONNABORTED") {
                return rejectWithValue("Request timed out.");
            }
            return rejectWithValue("Failed to fetch ticket status.");
        }
    }
);

const ticketsSlice = createSlice({
    name: 'tickets',
    initialState: {
        allData: {},
        commetData: {},
        loading: false,
        error: null,
        sessionResponse: "",
        sessionFlag: false,
        timeoutFlag: false,
    },
    reducers: {
        resetSessionFlag: (state) => {
            state.sessionFlag =  false;
        },
        resetTimeoutFlag: (state) => {
            state.timeoutFlag = false;
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchTicketStatus.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchTicketStatus.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload === "Logged out") {
                state.sessionResponse = "Session expired. Please login again.";
                state.sessionFlag = true;
                sessionStorage.removeItem('tokne');
            } else if (action.payload?.data === "Issue does not exist or you do not have permission to see it.") {
                state.allData = {};
                state.commetData = {};
            } else {
                state.allData = action.payload || {};
                state.commetData = action.payload?.comment || {};
                state.error = '';
            }
        })
        .addCase(fetchTicketStatus.rejected, (state, action) => {
            state.loading = false;
            if (action.payload === "Request timed out.") {
                state.timeoutFlag = true;
            } else {
                state.error = action.payload;
            }
        });
    }
});

export const { resetSessionFlag, resetTimeoutFlag } = ticketsSlice.actions;

export default ticketsSlice.reducer;